/**
 * True when an Axios/fetch request was aborted (superseded query, unmount, etc.).
 * Callers should rethrow these instead of wrapping them in domain API errors.
 */
export function isRequestAborted(error: unknown): boolean {
	if (typeof error !== "object" || error == null) return false;
	if ("code" in error && (error as { code?: string }).code === "ERR_CANCELED") {
		return true;
	}
	if (error instanceof Error && error.name === "CanceledError") {
		return true;
	}
	return error instanceof DOMException && error.name === "AbortError";
}
